/* eslint-disable */
import axios from 'axios'
import Qs from 'qs'
import router from '../router'
import cloudApi from './cloudStorageApi.js'

// axios.interceptors.request.use(function (config) {
//   if (store.getters.org) {
//     config.headers.tenant = '2333'
//   }
//   return config
// }, function (err) {
//   return Promise.reject(err);
// })
const apps = {
  cloudStorage: {
    name: '云存储接口',
    headerTitle: '法务云盘',
    description: '',
    baseUrl: ''
    // baseUrl: 'http://172.16.5.243:9191'
    // baseUrl: ''
    // baseUrl: 'http://172.16.5.216:9191'
  }
}

let http = {
  app: apps,
  request: function (api, params, header) {
    const app = apps[api.app]
    let url = app.baseUrl + api.path
    if (api.defaultParam) {
      params = Object.assign(api.defaultParam, params)
    }
    const data = Qs.stringify(params)
    let dataType = 'json'
    let method = 'POST'
    let timeout = null
    if (api.method != null || api.method !== undefined) {
      method = api.method
      if (method === 'get') {
        url += '?' + data
      }
    }

    if (api.dataType != null || api.dataType !== undefined) {
      dataType = api.dataType
    }

    if (api.timeout != null || api.timeout !== undefined) {
      timeout = api.timeout
    }
    var config = {
      url: url,
      method: method,
      withCredentials: true,
      emulateJSON: true,
      data: data,
      timeout: timeout,
      dataType: dataType,
      error: function () {
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
        'CS-NETWORKENV': 'public',
      }
    }
    if (header !== '' && header !== null && header !== undefined) {
      config.headers = Object.assign(config.headers, header)
    }
    return axios(config)
  }
}
let onLoginStatus = false
axios.interceptors.response.use((res) => {
  return res
}, function (error) {
  // let url = window.location.href
  console.log(error.response)
  if (error.response.data.errorCode === 'NO_LOGIN' || error.response.data.errorCode === '401' || error.response.data.errorCode === 'SESSION_TIME_OUT') {
    if (navigator.userAgent.toLowerCase().indexOf('yicbridge') !== -1) {
      if (onLoginStatus) {
        return
      }
      let sign = GetQueryString('sign')
      let _this = this
      onLoginStatus = true
      http.request(cloudApi.login2, { sign: sign }).finally(res => {
        onLoginStatus = false
      })
      return
    }
    window.sessionStorage.removeItem('mobileData')
    // window.location.href = url.slice(0, url.lastIndexOf('#') + 2) + 'login'
    // router.push({path: './index.html#/login'})
    router.push({ path: '/login' })
  }
  return Promise.reject(error)
})


export default http



// WEBPACK FOOTER //
// ./src/apis/index.js